"use client"

import { InfoIcon } from "@/app/icons/info"
import { Trans } from "@lingui/react/macro"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@rarible_int/anaconda_ui_components"
import { DropFee } from "./drop-fee"

export function DropFeeTooltip() {
  return (
    <Tooltip>
      <TooltipTrigger>
        <InfoIcon className="h-6 w-6 align-middle text-foreground/60" />
      </TooltipTrigger>
      <TooltipContent>
        <Trans>
          Fee: <DropFee className="[&>span]:text-foregroundInvert" /> per item
        </Trans>
      </TooltipContent>
    </Tooltip>
  )
}
